import React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import { useIntl } from 'react-intl-next';
import { EditDateMessages, IntlEditDateMessages } from '../edit/EditDateMessages.intl';
export var DatePickerMobile = function DatePickerMobile(_ref) {
  var id = _ref.id,
    dateValue = _ref.dateValue,
    onChange = _ref.onChange,
    isRequired = _ref.isRequired,
    label = _ref.label;
  var intl = useIntl();
  return /*#__PURE__*/React.createElement(DatePickerMobileStyles, null, /*#__PURE__*/React.createElement("input", {
    id: id,
    type: "date",
    value: dateValue,
    onChange: onChange ? function (event) {
      return onChange(event.target.value);
    } : undefined,
    placeholder: intl.formatMessage(IntlEditDateMessages[EditDateMessages.DatePlaceholder], {
      date: intl.formatDate(new Date(), {})
    }),
    required: isRequired,
    "aria-label": label
  }));
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var DatePickerMobileStyles = styled.div({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  '& > input': {
    whiteSpace: 'initial',
    display: 'flex',
    backgroundColor: "var(--ds-background-input, #f4f5f7)",
    borderColor: "var(--ds-border-inverse, #f4f5f7)",
    borderRadius: "var(--ds-border-radius, 3px)",
    marginBottom: "var(--ds-space-100, 8px)",
    boxShadow: 'none',
    borderStyle: 'solid',
    borderWidth: "var(--ds-border-width, 2px)",
    paddingTop: "var(--ds-space-100, 8px)",
    paddingBottom: "var(--ds-space-100, 8px)",
    paddingLeft: "var(--ds-space-075, 6px)",
    boxSizing: 'border-box',
    width: '100%',
    '&:hover': {
      backgroundColor: "var(--ds-background-input-hovered, #ebecf0)"
    }
  }
});